export function formatJobType(rowData) {
    if (!rowData) return '-';
    const topLevel = [];
    if (rowData.is_site_visit) topLevel.push('Site Visit');
    if (rowData.is_install) topLevel.push('Install');
    if (topLevel.length) return topLevel.join(', ');
    if (Array.isArray(rowData.job_types) && rowData.job_types.length) {
        return rowData.job_types.join(', ');
    }
    const set = new Set();
    const eqs = rowData.equipments || rowData.equipment_list || [];
    for (const e of eqs) {
        if (!e) continue;
        if (e.is_service) set.add('Service');
        if (e.is_calibration) set.add('Calibration');
        if (e.is_warranty) set.add('Warranty');
        if (e.is_repair) set.add('Repair');
        if (e.is_install) set.add('Install');
    }
    return set.size ? Array.from(set).join(', ') : '-';
}
